import React, { useState, useEffect, useCallback } from "react";
import { Layout } from "antd";
import { useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import ActionsApi from "../../common/Apis/ActionsApi";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const Actions = () => {
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  let navigate = useNavigate();
  const { Content } = Layout;
  const [Actions, setActions] = React.useState([]);
  const getActions = useCallback(() => {
    ActionsApi.Listactions()
      .then((response) => {
        console.log(response);
        setActions(response.payloadDto);
        setTotalElements(response.totalElements);
        setTotalPages(response.totalPages);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [setActions]);
  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);
  useEffect(() => {
    getActions();
    PageLoading();
  }, [getActions, PageLoading]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = Actions.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const renderTableRows = () => {
    return paginatedData.map((item) => (
      <tr key={item.id} className="text-center">
        <td className="pt-3">{item.code}</td>
        <td className="pt-3"> {item.name}</td>
      </tr>
    ));
  };


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData.length > 0 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            maxVisiblePages={5}
            showPageInfo={true}
            totalItems={totalElements}
            pageSize={pageSize}
          />
        )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Actions;
